














import PopupEpisode from '@/views/templates/africadogs/PopupEpisode.vue'

export default
  components: {
    PopupEpisode
  }

  props:
    url:
      type: String
      default: ''
    movie_mode:
      type: String
      default: ''

  methods: {
    closePopup: () ->
      @$emit('closePopup')
  }
